// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Library Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import TabsComponent from "../../components/tabs-component/tabs-component";
import AccessAccount from "./components/access-account/access-account";
import BusinessAccount from "./components/business-account/business-account";
import instance from "../../store/axios";
import { CREATE_BREADCRUMB, LOADING } from "../../store/actions";

// Style Imports
import "./customer-profile.style.scss";

const CustomerProfile: React.FC = (): ReactElement => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const { customerId } = useParams();
  const [customerData, setCustomerData] = useState<any[]>();

  const items: any = [
    {
      key: "1",
      label: `Business account`,
      children: <BusinessAccount customerData={customerData} />,
    },
    {
      key: "2",
      label: `Access account`,
      children: <AccessAccount />,
    },
  ];

  useEffect(() => {
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Customers list",
            type: "link",
            link: "/home/customers-list",
          },
        ],
      },
    });
    getProfileData();
  }, []);

  const getProfileData = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/user/${customerId}`
      );
      setCustomerData(response.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
    }

    dispatch({ type: LOADING, payload: false });
  };

  return (
    <div className="customer-profile-container flex flex-col">
      {user?.permissions?.includes("add_saudi_kyc_backoffice") && <div className="flex justify-between items-center">
        <BreadcrumbComponent />
        <div
          onClick={() => {
            navigate(`/home/create-customer?customerId=${customerId}`);
          }}
          className="h-9 cursor-pointer px-2.5 py-1 bg-blue-500 rounded-[100px] outline outline-1 outline-offset-[-1px] outline-black inline-flex justify-center items-center gap-2"
        >
          <img src={"/images/white-add-square.svg"} alt="plus" />
          <div className="justify-start text-white text-xs font-medium font-['Montserrat']">
            Create a new business account
          </div>
        </div>
      </div>}
      <TabsComponent items={items} />
    </div>
  );
};

export default CustomerProfile;
